/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_PrivacyInputs */

const en_contact_privacy = /** @type {((inputs: Contact_PrivacyInputs) => LocalizedString) & { parts: (inputs: Contact_PrivacyInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Contact_PrivacyInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`We use your details only to reply. See our privacy policy.`)
		}),
		{
			parts: /** @type {(inputs: Contact_PrivacyInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "We use your details only to reply. See our " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "privacy policy" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "." }])
			})
		}
	)
);

const zh_contact_privacy = /** @type {((inputs: Contact_PrivacyInputs) => LocalizedString) & { parts: (inputs: Contact_PrivacyInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Contact_PrivacyInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`您的信息仅用于回复您。详见我们的隐私政策。`)
		}),
		{
			parts: /** @type {(inputs: Contact_PrivacyInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "您的信息仅用于回复您。详见我们的" }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "隐私政策" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "。" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "We use your details only to reply. See our privacy policy." |
*
* @param {Contact_PrivacyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const contact_privacy = /** @type {((inputs?: Contact_PrivacyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & { parts: (inputs?: Contact_PrivacyInputs, options?: { locale?: "en" | "zh" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Contact_PrivacyInputs, { locale?: "en" | "zh" }, { link: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Contact_PrivacyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh") return zh_contact_privacy(inputs)
			return en_contact_privacy(inputs)
		}),
		{
			parts: /** @type {(inputs?: Contact_PrivacyInputs, options?: { locale?: "en" | "zh" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh") return /** @type {{ parts?: (inputs: Contact_PrivacyInputs) => import('../runtime.js').MessagePart[] }} */ (zh_contact_privacy).parts?.(inputs) ?? [{ type: "text", value: zh_contact_privacy(inputs) }]
				return /** @type {{ parts?: (inputs: Contact_PrivacyInputs) => import('../runtime.js').MessagePart[] }} */ (en_contact_privacy).parts?.(inputs) ?? [{ type: "text", value: en_contact_privacy(inputs) }]
			})
		}
	)
);